import CloseIcon from "@mui/icons-material/Close";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { IconButton } from "@mui/material";
import Flex from "../../../../../../../../../components/Flex";
import ToggleTabs, {
  ToggleTabItem,
} from "../../../../../../../../../components/ToggleTabs";
import { CHART_COLORS } from "../../../../../../../../../components/app/provider/patient/chart";
import { PRIMITIVE, px } from "../../../../../../../../../tokens/design-tokens";

export type EncounterTab = "visit-note" | "forms-assessment";

const ENCOUNTER_TABS_DATA: ToggleTabItem<EncounterTab>[] = [
  { label: "Visit Note", value: "visit-note" },
  { label: "Forms & Assessment", value: "forms-assessment" },
];

interface EncounterTabsProps {
  activeTab: EncounterTab;
  onTabChange: (tab: EncounterTab) => void;
  isPanelExpanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
}

const EncounterTabs: React.FC<EncounterTabsProps> = ({
  activeTab,
  onTabChange,
  isPanelExpanded,
  onToggleExpand,
  onClose,
}) => {
  return (
    <ToggleTabs<EncounterTab>
      tabs={ENCOUNTER_TABS_DATA}
      activeTab={activeTab}
      onTabChange={onTabChange}
      containerSx={{
        borderBottom: `1px solid ${CHART_COLORS.borderLight}`,
        backgroundColor: CHART_COLORS.surfaceWhite,
        borderTopLeftRadius: isPanelExpanded
          ? px(PRIMITIVE.radius[8])
          : px(PRIMITIVE.radius[4]),
        borderTopRightRadius: isPanelExpanded
          ? px(PRIMITIVE.radius[8])
          : px(PRIMITIVE.radius[4]),
      }}
      rightActions={
        <Flex gap={1}>
          <IconButton
            size="small"
            onClick={onToggleExpand}
            sx={{
              color: CHART_COLORS.primary,
              "&:hover": {
                backgroundColor: "rgba(16, 78, 132, 0.1)",
              },
            }}
          >
            {isPanelExpanded ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
          </IconButton>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Flex>
      }
    />
  );
};

export default EncounterTabs;
